import script from "./DeleteGroupModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./DeleteGroupModal.vue?vue&type=script&lang=ts&setup=true"

import "./DeleteGroupModal.vue?vue&type=style&index=0&id=48000166&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48000166"]])

export default __exports__